const monthlyOkr = [
  { monthNumber: 1, okr: 237211.55 },
  { monthNumber: 2, okr: 296514.43 },
  { monthNumber: 3, okr: 339026.45 },
  { monthNumber: 4, okr: 360757.28 },
  { monthNumber: 5, okr: 463534.00 },
  { monthNumber: 6, okr: 523523.23 },
  { monthNumber: 7, okr: 591122.77 },
  { monthNumber: 8, okr: 594745.80 },
  { monthNumber: 9, okr: 542273.13 },
  { monthNumber: 10, okr: 552775.22 },
  { monthNumber: 11, okr: 712887.31 },
  { monthNumber: 12, okr: 716462.02 }
]

const monthlyRealData = [
  { monthNumber: 1, real: 355000.00},
  { monthNumber: 2, real: 430000.00 },
  { monthNumber: 3, real: 855000.00 },
  { monthNumber: 4, real: 888000.00 },
  { monthNumber: 5, real: 1241522.00 },
  { monthNumber: 6, real: 1054925.00 },
  { monthNumber: 7, real: 0 },
  { monthNumber: 8, real: 0 },
  { monthNumber: 9, real: 0 },
  { monthNumber: 10, real: 0 },
  { monthNumber: 11, real: 0 },
  { monthNumber: 12, real: 0 }
]

export const getRealData = () => {
  return monthlyRealData
}

export const getOkrData = () => {
  return monthlyOkr
}

export const getMonthOKR = (monthNumber) => {
  const foundOkr = monthlyOkr.find((month) => month.monthNumber === monthNumber)

  if (foundOkr) {
    return foundOkr.okr
  }
}

export const getToCurrentMonthOKR = () => {
  const indexCurrentMonth = new Date().getMonth() + 1

  return monthlyOkr
    .filter((okr) => okr.monthNumber <= indexCurrentMonth)
    .map((okr) => okr.okr)
}

export const getSumOKR = () => {
  return monthlyOkr.reduce((acc, curr) => acc + curr.okr, 0)
}

export const getSumRealData = (realData) => {
  return realData.reduce((acc, curr) => acc + curr, 0)
}
